import { getCombinedSidesPadding, waitForElement } from '../base'

// Funkce pro získání URL obrázků produktu
// Vrací pole URL obrázků produktu
function getProductImages() {
    const images = document.querySelectorAll('.p-thumbnails-inner .p-thumbnail')

    let imageSrcArray = []
    images.forEach((image) => {
        imageSrcArray.push(image.href)
    })
    return imageSrcArray
}

// Funkce pro vytvoření HTML šablony pro Swiper galerii obrázků
// @param images - Pole URL obrázků
// @param name - Název třídy pro Swiper galerii
// Vrací HTML šablonu pro Swiper galerii obrázků
function swiperTemplate(images, name) {
    const padding = getCombinedSidesPadding('#content-wrapper')
    const detailWidth = window.innerWidth - padding

    const swiperSlidesHtml = images
        .map(
            (imageUrl) => `
                <div class="swiper-slide" data-src="${imageUrl}">
                    <img src="${imageUrl}" alt="Slide Image">
                </div>
            `
        )
        .join('')

    return /* HTML */ `
        <div class="p-image-custom">
            <div class="swiper ${name}" style="max-width: ${detailWidth}px">
                <div class="swiper-wrapper">${swiperSlidesHtml}</div>
                <div class="swiper-navigation">
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
            </div>
        </div>
    `
}

// Funkce pro inicializaci Swiper galerie
// Vrací instanci Swiper galerie
function initializeSwiper(selector) {
    return new Swiper(selector, {
        loop: true,
        slidesPerView: 'auto',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        keyboard: {
            enabled: true,
        },
    })
}

// Funkce pro přidání click eventu na jednotlivé obrázky v hlavní Swiper galerii
// umožňuje po kliknutí otevřít modální galerii s aktuálním obrázkem z hlavní galerie
function addClickEventToSlides(swiperGallery, imageSrcArray) {
    const sliders = document.querySelectorAll('.p-image-wrapper .swiper-slide')

    sliders.forEach((slide) => {
        slide.addEventListener('click', () => {
            openGalleryModal(imageSrcArray, swiperGallery)
        })
    })
}

// Funkce pro otevření modálního okna s galerii a aktuálním obrázkem
function openGalleryModal(imageSrcArray, swiperGallery) {
    shoptet.modal.open({
        html: swiperTemplate(imageSrcArray, 'swiper-product-gallery__modal'),
        width: 860,
        className: 'a-modal',
        onComplete: function () {
            shoptet.validator.initValidator($('form'))
            const swiperGalleryModal = initializeSwiper('.swiper-product-gallery__modal', imageSrcArray)

            swiperGalleryModal.slideToLoop(swiperGallery.realIndex, 0, false)
            swiperGallery.keyboard.disable()
            swiperGalleryModal.keyboard.enable()
        },
        onClosed: function () {
            swiperGallery.keyboard.enable()
        },
    })
}
// Funkce přidává click event pro základní Shoptet náhledy galerie, aby bylo možné přejít na konkrétní obrázek v naší custom swiper galerii
function slideToFromShoptetThumbnails(swiperGallery) {
    $('.p-thumbnail').on('click', function () {
        const index = $(this).index('.p-thumbnail')
        swiperGallery.slideTo(index)
    })
}

function moreThumbnails(swiperGallery) {
    const MIN_VISIBLE_THUMBNAILS = 6
    const NEXT_IMG = (MIN_VISIBLE_THUMBNAILS + 1) * 2

    const thumbnails = document.querySelectorAll('.p-thumbnails-inner .p-thumbnail')
    const thumbnailsParent = document.querySelector('.p-thumbnails-wrapper')

    if (!thumbnails || thumbnails.length <= MIN_VISIBLE_THUMBNAILS) return

    thumbnailsParent.classList.add('active-show-more')

    const moreImgsCount = thumbnails.length - MIN_VISIBLE_THUMBNAILS
    const thumbWrapper = document.querySelector('.p-thumbnails-inner > div')
    const moreImgs = `<div class = "show-more-img">+${moreImgsCount}</div>`

    thumbWrapper.insertAdjacentHTML('afterbegin', moreImgs)
    const showMore = document.querySelector('.show-more-img')

    showMore.addEventListener('click', (e) => {
        const index = $(`.p-thumbnails-inner > div .p-thumbnail:nth-child(${NEXT_IMG})`).index('.p-thumbnail')

        swiperGallery.slideTo(index)
    })
}

function slideToVariantImage() {
    const swiperGallery = document.querySelector('.swiper-product-gallery')
    const pImage = document.querySelector('.p-image .p-main-image img')?.getAttribute('src')

    if (!swiperGallery || !pImage) return

    const swiperInstance = swiperGallery.swiper

    swiperInstance.slideTo(
        swiperInstance.slides.findIndex((slide) => slide.getAttribute('data-src') === pImage),
        0,
        false
    )
}

// Funkce pro inicializaci mobilní galerie
// Přidá Swiper galerii do stránky, pokud je zařízení mobilní
// Funkce předělává Shoptet mobilní galerii na Swiper galerii, čímž umožňuje navigaci dotykem
export function initSwiperGallery() {
    const multipleImages = document.querySelector('.p-thumbnails-wrapper')

    if (multipleImages) {
        let isFirstChange = true
        const imageSrcArray = getProductImages()
        const swiperHtml = swiperTemplate(imageSrcArray, 'swiper-product-gallery')
        $('.p-image-wrapper .p-image').before(swiperHtml)
        $('.p-image .flags').appendTo('.p-image-custom')

        const swiperGallery = initializeSwiper('.swiper-product-gallery', imageSrcArray)

        slideToVariantImage()
        addClickEventToSlides(swiperGallery, imageSrcArray)
        slideToFromShoptetThumbnails(swiperGallery)
        moreThumbnails(swiperGallery)

        document.addEventListener('ShoptetSplitVariantParameterChange', () => {
            setTimeout(() => {
                if (!isFirstChange) {
                    slideToVariantImage()
                } else {
                    isFirstChange = false
                }
            }, 150)
        })
    } else {
        $('.p-image').addClass('d-block')

        waitForElement('.p-image .mousetrap').then(() => {
            $('.p-image .mousetrap').remove()
        })
    }
}
